import apiClient from "./api";


export async function getImplantBySec(data) {
  try {
    const response = await apiClient.get("/eomws/getimplantbysec", {params: data}); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return {
        success: false,
        message: "No response received",
        details: error.request,
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        success: false,
        message: "Request setup error",
        details: error.message,
      };
    }
  }
}

export async function useImplant(data) {
  try {
    const response = await apiClient.post("/eomws/useimplant", data); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return {
        success: false,
        message: "No response received",
        details: error.request,
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        success: false,
        message: "Request setup error",
        details: error.message,
      };
    }
  }
}

export async function getGrafts(data) {
  try {
    const response = await apiClient.get("/eomws/getimplantspercategory", {params: data}); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return {
        success: false,
        message: "No response received",
        details: error.request,
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        success: false,
        message: "Request setup error",
        details: error.message,
      };
    }
  }
}

export async function getTempSavedImplants(data) {
  try {
    const response = await apiClient.get("/eomws/gettempsavedimplants", {params: data}); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return {
        success: false,
        message: "No response received",
        details: error.request,
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        success: false,
        message: "Request setup error",
        details: error.message,
      };
    }
  }
}

export async function downloadExportTempSavedImplants(data) {
  try {
    const response = await apiClient.get('/eomws/exporttempsavedimplants', {
      responseType: 'blob', // Ensures the response is treated as a binary file
      params: data
    });

    // Create a URL for the blob
    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
    const url = window.URL.createObjectURL(blob);

    // Create a temporary anchor element to trigger the download
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', "Προσωρινά αποθηκευμένα.xlsx");

    // Append the link to the document, click it, and remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Revoke the URL to release memory
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading the file:', error);
  }
}

export async function getStatedImplants(data) {
  try {
    const response = await apiClient.get("/eomws/getinstall", {params: data}); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return {
        success: false,
        message: "No response received",
        details: error.request,
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        success: false,
        message: "Request setup error",
        details: error.message,
      };
    }
  }
}

export async function getImplantsForInstitute(data) {
  try {
    const response = await apiClient.get("/eomws/getimplantsforinstitude", {params: data}); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return {
        success: false,
        message: "No response received",
        details: error.request,
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        success: false,
        message: "Request setup error",
        details: error.message,
      };
    }
  }
}

export async function getGraftCategories() {
    try {
      const response = await apiClient.get("/eomws/implantcategories", {}); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: "No response received",
          details: error.request,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: "Request setup error",
          details: error.message,
        };
      }
    }
  }

export async function importImplantStatement(data) {
  try {
    const response = await apiClient.post("/eomws/inst_implant", data, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type
      },
    }); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return {
        success: false,
        message: "No response received",
        details: error.request,
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        success: false,
        message: "Request setup error",
        details: error.message,
      };
    }
  }
}
export async function postCategory(data) {
    try {
      const response = await apiClient.post("/eomws/postcategory", data); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: "No response received",
          details: error.request,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: "Request setup error",
          details: error.message,
        };
      }
    }
  }

  export async function instToHosp(data) {
    try {
      const response = await apiClient.post("/eomws/insttohosp", data); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: "No response received",
          details: error.request,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: "Request setup error",
          details: error.message,
        };
      }
    }
  }

  export async function postImplant(data) {
    try {
      const response = await apiClient.post("/eomws/postimplant", data); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: "No response received",
          details: error.request,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: "Request setup error",
          details: error.message,
        };
      }
    }
  }

  export async function actImplant(data) {
    try {
      const response = await apiClient.post("/eomws/actimplant", data); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: "No response received",
          details: error.request,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: "Request setup error",
          details: error.message,
        };
      }
    }
  }

  export async function deleteRelationsForImplant(data) {
    try {
      const response = await apiClient.post("/eomws/deleterelationsforimplant", data); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: "No response received",
          details: error.request,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: "Request setup error",
          details: error.message,
        };
      }
    }
  }